import api from '@/store/helpers/api';

export default {
  state: {
    imageStock: null,
    isMediaStorageOpen: false,
  },
  mutations: {
    SET_IMAGE_STOCK(state, imageStock) {
      state.imageStock = imageStock;
    },
    DELETE_IMAGE(state, image) {
      if (state.imageStock) {
        const indexBeingDeleted = state.imageStock.indexOf(image);
        state.imageStock.splice(indexBeingDeleted, 1);
      }
    },
    SET_OPEN_MEDIA_STORAGE(state, isMediaStorageOpen) {
      state.isMediaStorageOpen = isMediaStorageOpen;
    },
  },
  getters: {},
  actions: {
    loadMediaStorage({ commit, state }, options) {
      if (state.imageStock && !options?.refresh) {
        return state.imageStock;
      }

      return new Promise((resolve, reject) => {
        api
          .get('storage')
          .then((response) => {
            commit('SET_IMAGE_STOCK', response.data);
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    deleteImage({ commit }, image) {
      return new Promise((resolve, reject) => {
        const imageKey = image.url.split('amazonaws.com/')[1];

        api
          .delete(`storage/${imageKey}`)
          .then((response) => {
            commit('DELETE_IMAGE', image);
            resolve(response.data);
          })
          .catch(reject);
      });
    },
    findImageUses(store, image) {
      return new Promise((resolve, reject) => {
        const imageKey = image.url.split('amazonaws.com/')[1];

        api
          .get(`storage/usage/${imageKey}`)
          .then((response) => {
            const { pages, modals, favicon } = response.data;
            const inUse = pages.length > 0 || modals.length > 0 || favicon;
            const imageUsage = { inUse, ...response.data };

            resolve(imageUsage);
          })
          .catch(reject);
      });
    },
  },
};
